const moment = require("moment");

export const default_hygienic_measurement = () => {
    return {
        id: null,
        code: null,
        name: null,
        description: null,
        positions: []
    };
};

export const default_result = () => {
    return {
        id: null,
        date: moment().format('YYYY-MM-DD'),
        result: null,
        interpretation: null,
        protection_factor: null,
    };
};

export const default_params = () => {
    return {
        company_id: null,
        filter: null,
        paginate: 1,
        page: 1,
        per_page: 10
    };
};

export const default_params_results = () => {
    return {
        hygienic_measurement_id: null,
        company_id: null,
        filter: null,
        paginate: 1,
        page: 1,
        per_page: 10
    };
};

export default {
    companies: [],
    image: null,
    hygienic_measurements: {data: []},
    types: [],
    modal_image: {
        show: false,
        data: null
    },
    modal: {
        show: false,
        step: 0
    },
    hygienic_measurement: default_hygienic_measurement(),
    params: default_params(),
    editing: false,
    editing_control: false,
    editing_step: false,
    positions: [],
    results: {data: []},
    result: default_result(),
    components: [],
    interpretations: [
        {id: 1, text: 'Alta'},
        {id: 2, text: 'Media'},
        {id: 3, text: 'Baja'}
    ],
    params_results: default_params_results(),
    modal_results: {show: false},
    modal_result: {show: false},
    editing_result: false
};
